module.exports = __webpack_public_path__ + "static/media/book-circle.e873aaf7.svg";